<div class="container">
  <div>
    <div class="row">
      <div class="offset-md-2 col-md-8">
        <form [formGroup]="formGlobalReview" (ngSubmit)="onGlobalSubmit()" class="form-spec">
          <div>
            <h2 class="h4 mb-4">Mon témoignage concernant le club</h2>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label for="rate">Note*</label>
                  <div class="form-stars-radio-container">
                    <div *ngFor="let rate of [1,2,3,4,5,6,7,8,9,10]" class="form-single-star-radio-container">
                      <input type="radio" formControlName="rate" [value]="rate" class="" [ngClass]="{ 'is-invalid': submitted && gf['rate'].errors }">
                    </div>
                  </div>
                  <div *ngIf="selectedGlobalMark != null" class="form-stars-container">
                    <span *ngFor="let rate of [1,2,3,4,5,6,7,8,9,10]" class="form-single-star-container" (click)="changeGlobalMark(rate)">
                      <i *ngIf="rate <= selectedGlobalMark" class="mdi mdi-star"></i>
                      <i *ngIf="rate > selectedGlobalMark"  class="mdi mdi-star-outline"></i>
                    </span>
                  </div>
                  <div *ngIf="submitted && gf['rate'].errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && gf['rate'].errors }">
                      <div *ngIf="gf['rate'].errors['bad-mark']">Veuillez sélectionner une note</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group mb-2">
                  <label for="comment">Commentaire*</label>
                  <textarea type="text" formControlName="comment" class="form-control" [ngClass]="{ 'is-invalid': submitted && gf['comment'].errors }"></textarea>
                </div>
              </div>
            </div>

            <button [disabled]="loading" class="btn btn-primary mt-4">
                Valider
            </button>
          </div>
          <div class="form-legend">* Champ obligatoire</div>
        </form>
      </div>
    </div>
  </div>
</div>